interface Props {
    hidden: boolean;
}

/**
 * This is a tab for adding, removing, and editing textfields. Two widgets get injected here.
 */
export default function TextTab({ hidden }: Props) {
    return (
        <div className={`content-panel${hidden ? ' content-panel--hidden' : ''}`}>
            <div className='content-panel__title'>Text</div>
            <div className='content-panel__add-button'>
                <div className='dcl-widget-add-text' />
            </div>
            <div className='dcl-widget-edit-text' />
        </div>
    );
}
